<template>
    <svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M58.6654 10.0266C52.212 3.55781 43.6179 0 34.4846 0C15.6328 0 0.292634 15.3402 0.292634 34.192C0.292634 40.2141 1.86362 46.0975 4.85156 51.2879L0 69L18.1279 64.2408C23.1181 66.967 28.7397 68.3993 34.4692 68.3993H34.4846C53.321 68.3993 69 53.0592 69 34.2074C69 25.0741 65.1187 16.4953 58.6654 10.0266ZM34.4846 62.6391C29.3712 62.6391 24.3656 61.2683 20.0069 58.6808L18.975 58.0647L8.22455 60.8833L11.0893 50.3946L10.4116 49.3165C7.56228 44.7884 6.0683 39.5672 6.0683 34.192C6.0683 18.5283 18.821 5.77567 34.5 5.77567C42.0931 5.77567 49.2241 8.73281 54.5839 14.108C59.9437 19.4833 63.2397 26.6143 63.2243 34.2074C63.2243 49.8864 50.1482 62.6391 34.4846 62.6391Z" :fill="color"/>
        <path d="M20.4091 24.7273L26.4659 43.0455H26.7045L32.75 24.7273H37.3864L29.1818 48H23.9773L15.7841 24.7273H20.4091ZM49.6903 24.7273V48H45.4744V28.8295H45.3381L39.8949 32.3068V28.4432L45.679 24.7273H49.6903Z" :fill="color"/>
    </svg>

</template>
<script>
export default {
    name: "WhatsappV1",
    props: {
        color: {
            type: String,
            default: "#fff",
        },
    },
};
</script>
